import {ComputedRef, InjectionKey, Ref} from "vue";
import {FieldRowType, TableFieldsType} from "@/domain/task";
import {KeyStringLabelString} from "@/domain/catalog";
import { ColumnConfig } from "@/domain/ppa";

export const NUMERIC_TYPES = ["money", "number"];
export const NO_VALUE_FIELDS = ["title", "table"];

export const SMILES = [
	"👍",
	"👎",
	"✅",
	"❌",
	"😀",
	"😪",
	"😭",
	"😁",
	"😎",
	"😀",
	"😅",
	"😂",
	"😊",
	"😇",
	"😘",
	"🙃",
	"🤯",
	"😱",
	"😬",
	"🧐",
	"🥳",
	"😐",
	"🤗",
	"😡",
	"😩",
	"😒",
	"😞",
	"💪",
	"✋",
	"🙏",
	"👌",
	"🤌",
	"✌️",
	"🔕",
	"🔇",
	"🔈",
	"🔔",
	"💩",
	"👾",
	"🚀",
	"🌎",
	"💥",
	"🔥",
	"📞",
	"📆",
	"📊",
	"📎",
	"🔓",
	"⭐️",
	"💡",
	"❓",
	"⁉️",
	"❗️",
	"⚠️",
	"🇷🇺",
	"🔴",
	"🟠",
	"🟡",
	"🟢",
	"🔵",
	"🟣",
	"⚫️",
	"⚪️",
	"🟤",
];

export enum ErrorText  {
	EmptyString = "Поле должно быть заполнено",
	ValidEmail = "Неверный формат почты",
	ValidPhone = "Неверный формат номера телефона. Валидный формат: +79999999999",
	ValidTime = "Неверный формат времени",
	ValidDate = "Неверный формат даты",
	ValidDefault = "Неверно заполнено поле"
}


export const TABLE_FIELD_HEIGHT = 21;
export const FIELD_HEIGHT = 20;


export enum ConditionType {
	Equal = 1,
	NotEqual,
	NotEmpty,
	Empty,
	StartWithValue,
	EndWithValue,
	IncludesValue
}

export const STRING_CONDITIONS = [
    ConditionType.EndWithValue,
    ConditionType.IncludesValue,
    ConditionType.StartWithValue,
];
export const STRING_ARRAY_TYPES = ['catalog', 'multi_catalog'];


export enum notificationStatus {
    connection = 0,
    link,
    error,
    success,
    warning,
    info
}

export const catalogTypeRu = {
	"title": "Группа",
	"table": "Таблица",
	"text": "Текст",
	"due_date": "Дата системная",
	"due_date_time": "Дата и время",
	"date": "Дата",
	"time": "Время",
	"multi_catalog": "Мультикаталог",
	"email": "Почта",
	"phone": "Телефон",
	"money": "Деньги",
	"catalog": "Список",
	"number": "Номер",
	"pinned_link": "Ссылка",
	"checkmark": "Галочка",
	"note": "Заметки",
	"routing": "Маршрутизация",
	"file": "Файл",
}



export const ppaColumnsTypeRu: ColumnConfig[] = [
//   { key: 'id', label: 'id'},
  { key: 'vehicle_type', label: 'Тип ТС' , filterTable : true},
  { key: 'brand_name', label: 'Марка', filterTable : true },
  { key: 'model_name', label: 'Модель', filterTable : true },
  { key: 'year_of_issue', label: 'Год выпуска' },
  { key: 'monitoring', label: 'Мониторинг' },
  { key: 'secure_lock', label: 'Безопасная блокировка' },
  { key: 'dangerous_lock', label: 'Опасная блокировка' },
  { key: 'can', label: 'CAN' },
  { key: 'dut', label: 'ДУТ' },
  { key: 'temperature_sensor', label: 'Датчик температуры' },
  { key: 'angle_sensor', label: 'ДУН' },
  { key: 'installation_fact', label: 'Факт установки' },
  {	key: 'rulse_link', label: 'Rulse', linkText: 'Rulse'},
  { key: 'material_link', label: 'Ссылка', linkText: 'Ссылка' },
  { key: 'note', label: 'Примечание' },

];

export const montageColumnsTypeRu: ColumnConfig[] = [
//   { key: 'id', label: 'id'},
  { key: 'vehicle_type', label: 'Тип ТС', filterTable : true },
  { key: 'brand_name', label: 'Марка', filterTable : true },
  { key: 'model_name', label: 'Модель', filterTable : true },
  { key: 'year_of_issue', label: 'Год выпуска' },
  { key: "blocking" , label: "Блокировка"},
  { key: "regular_dut" , label: "ШДУТ"},
  { key: 'btx_link', label: 'Ссылка', linkText: 'Ссылка' },
  { key: 'note', label: 'Примечание' },
];


export const FIELD_LIST = [
    {name: "Группа", type: "title", fields: [], icon: 'TitleOutlined.svg'},
    {name: "Таблица", type: 'table', columns: [], icon: "TableSimple20Regular.svg"},
    {name: "Текст", type: 'text', icon: "DrawText20Filled.svg"},
    {name: "Дата системная", type: 'due_date', icon: "CalendarLtr48Regular.svg"},
    {name: "Дата и время", type: 'due_date_time', icon: "AccessTimeFilled.svg"},
    {name: "Дата", type: 'date', icon: "CalendarLtr48Regular.svg"},
    {name: "Время", type: 'time', icon: "timer.svg"},
    {name: "Мультикаталог", type: 'multi_catalog', icon: "Catalog.svg"},
    {name: "Почта", type: 'email', icon: "smsTracking.svg"},
    {name: "Телефон", type: 'phone', icon: "LocalPhoneRound.svg"},
    {name: "Деньги", type: 'money', icon: "DollarCircleOutlined.svg"},
    {name: "Список", type: 'catalog', icon: "ChecklistRound.svg"},
    {name: "Номер", type: "number", icon: "SortAscendingNumbers.svg"},
    {name: "Ссылка", type: 'pinned_link', icon: "AddLinkFilled.svg"},
    {name: "Галочка", type: 'checkmark', icon: "LibraryAddCheckOutlined.svg"},
    {name: "Заметки", type: 'note', icon: "Note16Regular.svg"},
    {name: "Маршрутизация", type: 'routing', icon: "routingIcon.svg"},
    {name: "Файл", type: 'file', icon: "fileIcon.svg"},
]


export const IMAGE_EXTENSION = ["png", "svg", "jpg", "jpeg"];
export const VIDEO_EXTENSION = ["mp4", "mov", "avi", "wmv", "mkv"];
export const AUTOPLAY_EXTENSION = ["webp", 'gif'];

export const catalogTypeImage = {
    "title": "TitleOutlined.svg",
    "table": "TableSimple20Regular.svg",
    "text": "DrawText20Filled.svg",
    "due_date": "CalendarLtr48Regular.svg",
    "due_date_time": "AccessTimeFilled.svg",
    "date": "CalendarLtr48Regular.svg",
    "time": "timer.svg",
    "multi_catalog": "Catalog.svg",
    "email": "smsTracking.svg",
    "phone": "LocalPhoneRound.svg",
    "money": "DollarCircleOutlined.svg",
    "catalog": "ChecklistRound.svg",
    "number": "SortAscendingNumbers.svg",
    "pinned_link": "AddLinkFilled.svg",
    "checkmark": "LibraryAddCheckOutlined.svg",
    "note": "Note16Regular.svg",
    "routing": "routingIcon.svg",
    "file": "fileIcon.svg",
}


export const POPULAR_FORMS: string[] = [
	"МР",
	"СР",
	"МР Новый",
	"СР новый",
	"ПЗ",
	"Доставка",
	"Выдача",
	"ПХД",
	"ТО",
	"Ежедневный отчет",
	"Инвентаризация",
	"Проверка Трекера"
]

export const sortByOptions = [
	{label: 'Все', value: 'ALL'},
	{label: 'Завершенные', value: '1'},
	{label: 'Без завершенных', value: '0'},
]

export const sortDirectionOptions = [
	{label: 'Без направления', value: null},
	{label: 'По возрастанию', value: '1'},
	{label: 'По убыванию', value: '0'},
]


export const  notificationInjectKey = Symbol() as InjectionKey<{createTaskId: Ref<number | null>, updateCreateTaskId:
		(taskId:number) => void}>


export interface  InjectedTableFieldType  {
	tableValues: ComputedRef<FieldRowType<TableFieldsType>[]>
	updateTableValues: (newTableValues: FieldRowType<TableFieldsType>[]) => void
}
export const tableFieldKey = Symbol() as InjectionKey<InjectedTableFieldType>
export const registryFilterMap = {
	filled: 'заполнено',
	contains: 'содержит',
	exact_num: 'равно',
	num_start: 'от',
	num_end: 'до',
	exact_bool: 'равно',
	catalog_values: 'содержит',
	date_start: 'от',
	date_end: 'по',
	user_ids: 'включает',
	department_ids: 'включает',
}

export const approveOptions:KeyStringLabelString[]  = [
	{
		label: `Утверждено`,
		key: "approved",
	},
	{
		label: 'Против',
		key: "revoke"
	},
]

export const approveOptionsInChat:KeyStringLabelString[]  = [
	{
		label: `Утверждено`,
		key: "approved",
	},
	{
		label: 'Против',
		key: "revoke"
	},
	{
		label: 'Отмена',
		key: ""
	},
]

export const dateStringOptions : Intl.DateTimeFormatOptions = {
	day: '2-digit',
	month: '2-digit',
	year: 'numeric',
	hour: '2-digit',
	minute: '2-digit'
}

export const closedTaskFilterOptions: Array<{label: string, key: string}> = [
	{
		label: "Завершенные",
		key: "1"
	},
	{
		label: 'Незавершенные',
		key: '0'
	},
	{
		label: "Все",
		key: "3"
	},
]

export const closedTaskListOptions: Array<{label: string, key: string}> = [
	{
		label: "Завершенные",
		key: "1"
	},
	{
		label: 'Незавершенные',
		key: '0'
	},
	{
		label: "Все",
		key: "ALL"
	},
]

export const imagesExtension = ["png", "svg", "jpg", "jpeg"]
